import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc controller
     * @name ContractingServicesCtrl
     * @memberof app
     *
     * @description
     * Contracting Services of Assignment of TSOs for Account Settings
     *
     * @author bjnowak.btc
     */
    angular
        .module('app')
        .controller('ContractingServicesCtrl', ContractingServicesCtrl);

    function ContractingServicesCtrl(
        $log,
        $routeParams,
        $rootScope,
        TransmissionSystemOperator
    ) {
        var vm = this;

        vm.featureToggles = $rootScope.featureToggles;
        vm.submitContract = submitContract;
        vm.submitContractRes = null;
        vm.submitError = false;
        vm.tso = null;
        vm.contract = {
            service: null,
            fields: []
        };
        vm.contractingService = { fields: [] };
        vm.disableSubmit = false;

        getTso();

        function getTso() {
            if (angular.isDefined($routeParams.id)) {
                vm.tso = TransmissionSystemOperator.get(
                    { id: $routeParams.id },
                    function (res) {
                        vm.tso = res;
                        if (vm.tso.contractingServicesList.length === 1) {
                            vm.contract.service =
                                vm.tso.contractingServicesList[0];
                        }
                        $log.debug('TSO data fetched: ' + JSON.stringify(res));
                    },
                    function (err) {
                        vm.tso = null;
                        $log.error('Error getting TSO data: ' + err);
                    }
                );
            }
        }

        function submitContract(isValid) {
            if (vm.submitContractRes) {
                resetForm();
                getTso();
            } else {
                if (!isValid) {
                    return false;
                }
                vm.disableSubmit = true;

                var param = {
                    id: vm.tso.id,
                    service: vm.contract.service.serviceLabel
                };

                TransmissionSystemOperator.submitContractingService(
                    param,
                    vm.contractingService,
                    function () {
                        vm.submitContractRes = true;
                        vm.submitError = false;
                    },
                    function () {
                        vm.submitContractRes = false;
                        vm.submitError = true;
                    }
                ).$promise.finally(function () {
                    vm.disableSubmit = false;
                });
            }
        }

        function resetForm() {
            vm.contractingService.fields = [];
            vm.submitContractRes = false;
            vm.contract = {
                service: null,
                fields: []
            };
            vm.serviceForm.$submitted = false;
        }
    }
})();
